import * as React from 'react'
import { TagPro } from '@roo/roo'
import useOrderMaps from '../../utils/useOrderMaps'
import { BizOrderStatusEnum } from '../../types'
import styles from './index.module.less'
type OrderStatusTagProps = {
  status: BizOrderStatusEnum
}

const statusColorMap: Record<number, string> = {
  [BizOrderStatusEnum.Submitted]: 'info',        // 已提单
  [BizOrderStatusEnum.Paid]: '#108ee9',       // 已支付
  [BizOrderStatusEnum.Confirmed]: '#108ee9',     // 商家已确认
  [BizOrderStatusEnum.Completed]: 'success',     // 已完成
  [BizOrderStatusEnum.Cancelled]: 'disabled',       // 已取消
}

const OrderStatusTag: React.FC<OrderStatusTagProps> = ({ status }) => {
  const { statusMap } = useOrderMaps()
  const tagType = statusColorMap[status]
  const statusText = statusMap[status]
  if (!statusText) return '--'

  return (
    <TagPro color={tagType} style={{ height: 'auto', maxWidth: '100%' }} className={styles.tag}>
      {statusText}
    </TagPro>
  )
}

export default OrderStatusTag
